import axios from 'axios'
import moment from 'moment'
import { spEsri } from '../../globals.js'

export default {
  computed: {
    dateFormat () {
      if (this.$store.getters.getConfigJson.appConfig.dateFormat) {
        return this.$store.getters.getConfigJson.appConfig.dateFormat
      }
      return 'MM/DD/yyyy'
    },
    hiddenFields () {
      return this.$store.getters.getConfigJson.appConfig.hiddenFields
    },
    hiddenFieldsCustom () {
      return this.$store.getters.getConfigJson.appConfig.hiddenFieldsCustom ? this.configJson.appConfig.hiddenFieldsCustom : {}
    },
    hiddenRelations () {
      return this.$store.getters.getConfigJson.appConfig.hiddenRelations ? this.$store.getters.getConfigJson.appConfig.hiddenRelations : {}
    },
  },
  methods: {
    // TODO could make it so that this gets called by default for every layer that is loaded
    // so that we'd have objects instead of arrays, which would reduce lookup time
    createMapFromFieldsArray (fields) {
      const fieldsObj = {}

      for (const field of fields) {
        fieldsObj[field.name] = field
      }
      return fieldsObj
    },
    refreshLayer (key) {
      if (spEsri.mapImageLayers[key]) {
        spEsri.mapImageLayers[key].refresh()
      } else if (spEsri.featureLayers[key]) {
        spEsri.featureLayers[key].refresh()
      }
    },
    processFeature (feature, featureLayer) {
      const subtypeField = featureLayer.typeIdField
      const attrs = {}
      // get domain values
      const allFields = featureLayer.fields
      for (const field of allFields) {
        if (field.domain !== undefined && field.domain !== null) {
          const key = field.name
          const attValue = feature.attributes[key]
          if (attValue != null) {
            const codedValues = field.domain.codedValues
            for (const codedValue of codedValues) {
              if (codedValue.code === attValue || codedValue.name === attValue) {
                attrs[field.name] = codedValue.name
              }
            }
          } else {
            attrs[field.name] = attValue
          }
        } else if (!attrs[field.name]) {
          attrs[field.name] = feature.attributes[field.name]
        }
      }

      for (const attr in feature.attributes) {
        // find subtypes and corresponding domains
        if (subtypeField !== null && attr === subtypeField) {
          const subtypeValues = featureLayer.types
          for (const subtype of subtypeValues) {
            if (subtype.id === feature.attributes[attr]) {
              attrs[attr] = subtype.name
              for (const domain in subtype.domains) {
                if (subtype.domains[domain].codedValues) {
                  const val = feature.attributes[domain]
                  for (const domainItem of subtype.domains[domain].codedValues) {
                    if (domainItem.code === val) {
                      attrs[domain] = domainItem.name
                    }
                  }
                }
              }
            }
          }
        }
      }

      const displayFieldName = featureLayer.displayField
      for (const fLField of featureLayer.fields) {
        if (fLField.type === 'date') {
          if (attrs[fLField.name]) {
            attrs[fLField.name] = this.formatDate(new Date(attrs[fLField.name]))
          }
        }
        if (attrs[fLField.name] === undefined || attrs[fLField.name] === null) {
          attrs[fLField.name] = '-'
        }
        attrs[fLField.name] = {
          name: fLField.name,
          alias: fLField.alias,
          value: attrs[fLField.name],
        }
        let cmpName = ''
        if (fLField.alias) {
          cmpName = fLField.alias
        } else {
          cmpName = fLField.name
        }
        if (this.isKeyValid(featureLayer.url + '/' + featureLayer.layerId, cmpName)) {
          attrs[fLField.name].visible = true
        } else {
          attrs[fLField.name].visible = false
        }
      }
      if (attrs[displayFieldName] !== undefined && attrs[displayFieldName] !== null) {
        feature.displayField = attrs[displayFieldName].value
      } else {
        feature.displayField = '-'
      }
      return attrs
    },
    isKeyValid (url, key) {
      let hidden = []
      const noHiddenFields = this.hiddenFieldsCustom[url]?.visibleFields
      const additionalHiddenFields = this.hiddenFieldsCustom[url]?.hiddenFields
      if (this.hiddenFields) {
        for (const hiddenField of this.hiddenFields) {
          if (noHiddenFields?.includes(hiddenField)) {
            continue
          } else {
            hidden.push(hiddenField)
          }
        }
      }
      if (additionalHiddenFields) {
        hidden = [...hidden, ...additionalHiddenFields]
      }
      return !hidden.includes(key)
    },
    processFeatureResult (result, featureLayer, isResult) {
      const subtypeField = featureLayer.typeIdField
      const formattedAttributes = {}
      for (const attr in result.attributes) {
      // find subtypes and corresponding domains
        if (attr === subtypeField) {
          const subtypeValues = featureLayer.types
          for (const subtype of subtypeValues) {
            if (subtype.id === result.attributes[attr]) {
              formattedAttributes[attr] = subtype.name
              for (const domain in subtype.domains) {
                if (subtype.domains[domain].codedValues) {
                  const val = result.attributes[domain]
                  for (const domainItem of subtype.domains[domain].codedValues) {
                    if (domainItem.code === val) {
                      formattedAttributes[domain] = domainItem.name
                    }
                  }
                }
              }
            }
          }
        }
      }
      // get domain values
      const allFields = featureLayer.fields
      for (const field of allFields) {
        if (field.domain?.codedValues?.length > 0) {
          const key = field.name
          const attValue = result.attributes[key]
          if (attValue != null) {
            const codedValues = field.domain.codedValues
            for (const codedValue of codedValues) {
              if (codedValue.code === attValue) {
                formattedAttributes[field.name] = codedValue.name
              }
              if (codedValue.name === attValue) {
                formattedAttributes[field.name] = codedValue.name
              }
            }
          } else {
            formattedAttributes[field.name] = attValue
          }
        } else if (!formattedAttributes[field.name]) {
          formattedAttributes[field.name] = result.attributes[field.name]
        }
      }
      if (!isResult) {
        for (const fLField of featureLayer.fields) {
          if (fLField.type === 'date') {
            if (formattedAttributes[fLField.name]) {
              formattedAttributes[fLField.name] = this.formatDate(new Date(formattedAttributes[fLField.name]))
            }
          }
        }
      }
      return formattedAttributes
    },
    formatDate (date) {
      return moment(String(date)).format(this.dateFormat)
    },
    appendArcGISPortalToken (url, token) {
      if (token) {
        url += '&token=' + token
      }
      return url
    },
    async checkIfAServiceIsProtected (services) {
      if (services.length <= 0) {
        return false
      }

      for (const service of services) {
        const response = await axios.get(service.mapURL + '?f=json')
        if (response.data.error?.code === 499) {
          return true
        }
      }
      return false
    },
  },
}
